// extracted by mini-css-extract-plugin
export default {"chevronColor":"#b5bac8","listItem":"style--listItem--eda773","checkboxContainer":"style--checkboxContainer--65c37d","assignationsBadges":"style--assignationsBadges--62681b"};